/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Presets_None_TextInputs */

const en_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subtitle export presets have been saved yet. Create a preset by clicking "Save Preset".`)
};

const fr_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage d'exportation de sous-titres n'a encore été enregistré. Créez un préréglage en cliquant sur « Enregistrer le préréglage ».`)
};

const de_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden noch keine Untertitel-Exportvoreinstellungen gespeichert. Erstellen Sie eine Voreinstellung, indem Sie auf „Voreinstellung speichern“ klicken.`)
};

const it_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sono ancora stati salvati preset di esportazione dei sottotitoli. Crea un preset cliccando su "Salva preset".`)
};

const ru_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока не сохранено ни одного настроенного параметра экспорта субтитров. Создайте параметр, нажав кнопку «Сохранить параметр».`)
};

const es_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han guardado ajustes preestablecidos para la exportación de subtítulos. Cree uno haciendo clic en "Guardar ajuste preestablecido".`)
};

const zh_cn2_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未保存任何字幕导出预设。点击“保存预设”创建预设。`)
};

const ja_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕エクスポートプリセットはまだ保存されていません。「プリセットを保存」をクリックしてプリセットを作成してください。`)
};

const hi_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई सबटाइटल एक्सपोर्ट प्रीसेट सेव नहीं किया गया है। "सेव प्रीसेट" पर क्लिक करके एक प्रीसेट बनाएं।`)
};

const pt_pt2_subtitle_export_presets_none_text = /** @type {(inputs: Subtitle_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição de exportação de legendas foi salva ainda. Crie uma predefinição clicando em "Salvar predefinição".`)
};

/**
* | output |
* | --- |
* | "No subtitle export presets have been saved yet. Create a preset by clicking \"Save Preset\"." |
*
* @param {Subtitle_Export_Presets_None_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_presets_none_text = /** @type {((inputs?: Subtitle_Export_Presets_None_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Presets_None_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_presets_none_text(inputs)
	if (locale === "de") return de_subtitle_export_presets_none_text(inputs)
	if (locale === "it") return it_subtitle_export_presets_none_text(inputs)
	if (locale === "ru") return ru_subtitle_export_presets_none_text(inputs)
	if (locale === "es") return es_subtitle_export_presets_none_text(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_presets_none_text(inputs)
	if (locale === "ja") return ja_subtitle_export_presets_none_text(inputs)
	if (locale === "hi") return hi_subtitle_export_presets_none_text(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_presets_none_text(inputs)
	return en_subtitle_export_presets_none_text(inputs)
});